// services/time-supplement.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

import { IPagedResults } from 'src/app/core/models/base';
import { ICreateTimeSupplementRequest, ISearchTimeSupplementsRequest, ITimeSupplement, IUpdateTimeSupplementRequest } from './time-supplement';

@Injectable({
  providedIn: 'root'
})
export class TimeSupplementService {

  constructor(private http: HttpClient) {}

  searchTimeSupplements(request: ISearchTimeSupplementsRequest = null) {
    return this.http.post<IPagedResults<ITimeSupplement[]>>(
      `${environment.baseUrl}/v1/timeSupplement/searchTimeSupplements`,
      request
    );
  }

  createTimeSupplement(request: ICreateTimeSupplementRequest) {
    return this.http.post<ITimeSupplement>(
      `${environment.baseUrl}/v1/timeSupplement/createTimeSupplement`,
      request
    );
  }

  updateTimeSupplement(request: IUpdateTimeSupplementRequest) {
    return this.http.put<ITimeSupplement>(
      `${environment.baseUrl}/v1/timeSupplement/updateTimeSupplement/${request.id}`,
      request
    );
  }

  deleteTimeSupplement(id: string) {
    return this.http.delete(
      `${environment.baseUrl}/v1/timeSupplement/deleteTimeSupplement/${id}`
    );
  }
}
